// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titleBarContainer_IyrOV {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.searchContainer_Mgggl {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.searchSpace_jqtw_ {
  flex-grow: 1;
}

.searchFlexContainer_zKK5U {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.searchInput_hyLEI {
  width: 300px !important;
}

.tableCell_EJk19 {
  padding-left: 8px;
}

.arrayCell_y0CBb {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap : 8px;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/searchUsers/SearchUsers.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".titleBarContainer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.searchContainer {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.searchSpace {\n  flex-grow: 1;\n}\n\n.searchFlexContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.searchInput {\n  width: 300px !important;\n}\n\n.tableCell {\n  padding-left: 8px;\n}\n\n.arrayCell {\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap : 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleBarContainer": `titleBarContainer_IyrOV`,
	"searchContainer": `searchContainer_Mgggl`,
	"searchSpace": `searchSpace_jqtw_`,
	"searchFlexContainer": `searchFlexContainer_zKK5U`,
	"searchInput": `searchInput_hyLEI`,
	"tableCell": `tableCell_EJk19`,
	"arrayCell": `arrayCell_y0CBb`
};
export default ___CSS_LOADER_EXPORT___;
